var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdPlanPerkVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#ffe70d",
    opacity: 1,
    "data-original": "#ffdd55",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed402",
    d: "m106 381 130.249 130.249c6.518.497 13.105.751 19.751.751 141.385 0 256-114.615 256-256 0-6.646-.254-13.233-.751-19.751L406 131z",
    opacity: 1,
    "data-original": "#edbe00",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5b5b",
    d: "M315.531 235.08 256 339.416l-150-11.342V131h150z",
    opacity: 1,
    "data-original": "#ff5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8001c",
    d: "m406 328.074-150 11.342V131h150z",
    opacity: 1,
    "data-original": "#c8001c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#843eea",
    d: "M256 381H106v-53.902h150l29.766 27.354z",
    opacity: 1,
    "data-original": "#6c67d2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6730b6",
    d: "M256 327.098h150V381H256z",
    opacity: 1,
    "data-original": "#534dca",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6ff",
    d: "M129.036 346.416h253.929v16.071H129.036z",
    opacity: 1,
    "data-original": "#e6e6ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b7b5e9",
    d: "M256 346.416h126.964v16.071H256z",
    opacity: 1,
    "data-original": "#b7b5e9",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.5,
    cy: 354.452,
    r: 18.571,
    fill: "#9cd29a",
    opacity: 1,
    "data-original": "#9cd29a",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M217.899 283.896v-97.632l97.632 48.816z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6ff",
    d: "m256 264.845 59.531-29.765L256 205.314z",
    opacity: 1,
    "data-original": "#e6e6ff",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdPlanPerkVideoIcon);
export default __webpack_public_path__ + "static/media/ad-plan-perk-video-icon.fbfdfdb37d40f4d580e7ac15da6f2a37.svg";
export { ForwardRef as ReactComponent };